<template>
    <div class="relative flex items-center justify-center customPopup2 fixed w-full h-full z-[21474830004] left-0 top-0"
        v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
        <div id="modal_1"
            class="fixed top-0 z-50 flex items-start w-full h-screen overflow-scroll bg-gray-800 bg-opacity-50 sm:overflow-hidden">
            <div class="flex items-center justify-center w-full max-w-6xl mx-auto md:py-20 md:px-20 xs-max:relative">
                <div
                    class="relative flex flex-col items-center justify-center w-full max-w-screen-lg px-4 py-2 pt-5 pb-8 bg-white border-t-8 border-yellow-600 shadow-lg md:w-auto md:py-14 lg:px-12 xl:px-16">
                    <div class="w-full modal-header">
                        <div class="flex justify-between w-full mb-2 space-x-3 text-sm font-semibold">
                            <div class="item">Add to Cart</div>
                            <div class="text-center item sm:text-left">Upgrade Options</div>
                            <div class="text-right item">Secure Checkout</div>
                        </div>
                        <div class="w-full mb-3 progress progress-striped active">
                            <div class="progress-bar progress-bar-success"
                                :class="modal.crosssell.show ? 'w-3/4' : 'w-1/2'">
                                <span>&nbsp;</span>
                            </div>
                        </div>
                    </div>
                    <!-- modal body 1 start -->
                    <div class="w-full modal-body" v-show="modal.upsell.show">
                        <div class="w-full py-2 text-center bg-gray-100 border border-gray-300" role="banner">
                            <p class="m-0 text-lg lg:text-lg xl:text-xl" v-text="state.upgrade.UpSell.PreHeader"></p>
                            <p class="w-full px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 md:w-4/5 sm:text-2xl md:text-3xl lg:text-4xl font-ww-medium"
                                v-text="state.upgrade.UpSell.Header"></p>
                        </div>
                        <div class="flex items-center px-0 mt-4 space-x-4 md:space-x-8">
                            <div class="h-auto item">
                                <h3 role="main"
                                    class="text-2xl font-semibold leading-7 text-left text-gray-800 lg:text-3xl lg:leading-9">
                                    Lucky You!
                                </h3>
                                <div data-body-copy class="grid grid-cols-3 gap-2 overflow-hidden sm:grid-cols-8">
                                    <!-- You've found our
              <span class="italic">New Customer Special</span> - our
              biggest savings anywhere in our store. -->
                                    <p class="col-span-2 col-start-1 row-start-1 mt-2 text-base font-normal text-justify sm:col-span-6 sm:text-xl"
                                        v-text="state.upgrade.UpSell.SubHeader">
                                    </p>
                                    <div
                                        class="flex items-center col-span-2 row-start-1 sm:col-start-7 sm:col-span-2 sm:row-span-2 item">
                                        <img class="mx-auto sm:w-40" loading="lazy" :src="state.upgrade.UpSell.Image" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full space-y-3 text-center sm:px-5 md:space-y-4">
                            <a @click="emitSetChoice(true)" class="btn--special">Yes!
                                Upgrade My Savings
                                <svg class="absolute right-4 md:right-6 inset-y-0 my-auto h-2.5 lg:h-4 xl:h-auto w-auto"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 16 29" width="16px" height="29px">
                                    <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                                        d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                                    </path>
                                </svg>
                            </a>
                        </div>
                        <a @click="emitSetChoice(false)" href="javascript:void(0)"
                            class="block text-base leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none">No
                            thanks, I'll pass on this one-time offer</a>
                        <button @click="emitSetChoice(false)"
                            class="absolute text-gray-800 cursor-pointer top-4 right-4 lg:top-6 lg:right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                            aria-label="close">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                ...
                            </svg>
                        </button>
                    </div>
                    <!-- modal body 1 end -->
                    <!-- modal body 2 start -->
                    <div class="w-full modal-body" v-show="modal.crosssell.show">
                        <div class="w-full py-2 text-center bg-gray-100 border border-gray-300" role="banner">
                            <h3 class="px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 sm:text-2xl md:text-3xl lg:text-3xl font-ww-medium"
                                v-text="state.upgrade.CrossSell.Header"></h3>
                        </div>
                        <div data-body-copy class="grid grid-cols-3 gap-2 overflow-hidden sm:grid-cols-8">
                            <p class="col-span-2 col-start-1 row-start-1 mt-2 text-base font-normal text-justify sm:col-span-6 sm:text-xl"
                                v-text="state.upgrade.CrossSell.Body">
                            </p>
                            <p class="col-span-3 row-start-2 mt-2 text-base font-normal text-justify sm:col-start-1 sm:row-start-2 sm:col-span-6 sm:text-xl"
                                v-html="state.upgrade.CrossSell.PricenSave">
                            </p>
                            <div
                                class="flex items-center col-span-2 row-start-1 sm:col-start-7 sm:col-span-2 sm:row-span-2 item">
                                <img class="mx-auto sm:w-40" loading="lazy" :src="state.upgrade.CrossSell.Image" />
                            </div>
                        </div>
                        <div class="w-full px-5 space-y-3 text-center md:space-y-4">
                            <a @click="emitSetChoice(true)" data-add-upgrade-bundle class="btn--special">Yes!
                                Upgrade My Order
                                <svg class="absolute right-4 md:right-6 inset-y-0 my-auto h-2.5 lg:h-4 xl:h-auto w-auto"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 16 29" width="16px" height="29px">
                                    <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                                        d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                                    </path>
                                </svg>
                            </a>
                        </div>
                        <a @click="emitSetChoice(false)" data-add-default-final href="javascript:void(0)"
                            class="block text-sm leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none">
                            No thanks, I'll pass on this opportunity to try these three roasts
                            at a big discount…
                        </a>
                        <button @click="emitSetChoice(false)"
                            class="absolute text-gray-800 cursor-pointer top-6 right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                            aria-label="close">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                ...
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineBuilderComponent({
    friendlyName: "Core Modal",
    canHaveChildren: true
});

const { modal, state } = defineProps({
    modal: Object,
    state: Object
})

const emit = defineEmits(['set-choice'])

const emitSetChoice = (choice) => {
    emit('set-choice', choice)
}
</script>

<style scoped>
.progress {
  background-color: #f5f5f5;
  border-radius: 3px;
  box-shadow: none;
}

.progress-bar {
  background-color: #2196f3;
  box-shadow: none;
}

@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
}

.progress-bar.active,
.progress.active .progress-bar {
  -webkit-animation: progress-bar-stripes 2s linear infinite;
  -o-animation: progress-bar-stripes 2s linear infinite;
  animation: progress-bar-stripes 2s linear infinite;
}

.progress-bar-striped,
.progress-striped .progress-bar {
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-image: -o-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 40px 40px;
}

.progress-bar-success {
  background-color: #00a968;
}

button.cart-popup-close:after {
  display: inline-block;
  content: "\00d7";
}

button.cart-popup-close {
  background: none;
  color: inherit;
  border: none;
  font-family: "Gruppo";
  color: #4e4e4e;
  font-size: 30px;
  position: absolute;
  right: 15px;
  top: 10px;
}

.upgrade-save-btn {
  cursor: pointer;
}

.product-image img,
.temp-fix {
  height: 200px;
  object-fit: contain;
}

.fix-height {
  height: 125px;
  object-fit: contain;
}

.fix-one-height {
  height: 240px;
  object-fit: contain;
}

[x-cloak] {
  display: none !important;
}

.grayscale-1 {
  filter: grayscale(1);
  pointer-events: none;
}

.flex-viewport {
  min-height: 550px;
}

@media only screen and (min-width: 500px) {
  .flex-viewport {
    min-height: 650px;
  }
}
</style>